import React from "react";
import { cn } from "@/lib/utils";

export const Button = React.forwardRef(({ className, variant = "default", size = "default", ...props }, ref) => {
  const variants = {
    default: "bg-[#0F4C5C] text-white hover:bg-[#0D4250]",
    outline: "border border-[#E2E8F0] bg-white text-[#1A202C] hover:bg-[#F5F2EB]",
    ghost: "bg-transparent text-[#1A202C] hover:bg-[#F5F2EB]"
  };
  const sizes = {
    default: "h-10 px-4 py-2",
    sm: "h-9 px-3",
    lg: "h-11 px-8"
  };
  return (
    <button
      ref={ref}
      className={cn("inline-flex items-center justify-center rounded-lg text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50", variants[variant], sizes[size], className)}
      {...props}
    />
  );
});

Button.displayName = "Button";
